import { loadable } from '@fiverr-private/perseus';

const TalentCardGrid = loadable(() => import(/* webpackChunkName: "talentCardGrid" */ './components/TalentCardGrid'));

export const TALENT_CARD_GRID_CONFIG = {
    components: [
        {
            component: TalentCardGrid,
            options: {
                name: 'TalentCardGrid',
                inputs: [
                    {
                        name: 'userNames',
                        type: 'text',
                        required: true,
                        helperText: 'Comma-separated seller usernames',
                    },
                    {
                        name: 'count',
                        type: 'number',
                        helperText: 'Number of sellers to display (randomly selected from all usernames)',
                    },
                ],
                noWrap: false,
            },
        },
    ],
};
